import getErrorsState from './getErrorState';

function get(state) {
  return getErrorsState(state).globalError;
}

export default {
  get,
};
